module.exports = __webpack_public_path__ + "media/application/images/svgs/facebook-ea076c71acb75bd332a663796ef1055b.svg";